import { FaCheckCircle, FaClock, FaCircle } from 'react-icons/fa';
import './LoanStatusTracker.css';

const LoanStatusTracker = () => {
  // Sample data - shows different stages of loan application
  const stages = [
    {
      id: 1,
      name: 'Application Login',
      description: 'Submit your loan application',
      status: 'completed', // completed, in-progress, pending
      icon: FaCheckCircle
    },
    {
      id: 2,
      name: 'Sanction Process',
      description: 'Verification & approval',
      status: 'in-progress',
      icon: FaClock
    },
    {
      id: 3,
      name: 'Disbursement',
      description: 'Funds transferred to account',
      status: 'pending',
      icon: FaCircle
    }
  ];

  // Calculate progress percentage
  const completedStages = stages.filter(s => s.status === 'completed').length;
  const progressPercentage = (completedStages / stages.length) * 100;

  return (
    <div className="loan-status-tracker-container">
      <div className="tracker-header">
        <h2>Track Your Loan Status</h2>
        <p>Follow your loan application journey from submission to disbursement</p>
      </div>

      {/* Progress Bar */}
      <div className="progress-section">
        <div className="progress-bar-container">
          <div 
            className="progress-bar-fill" 
            style={{ width: `${progressPercentage}%` }}
          ></div>
        </div>
      </div>

      {/* Stages Timeline */}
      <div className="stages-timeline">
        {stages.map((stage, index) => {
          const Icon = stage.icon;
          const isLast = index === stages.length - 1;
          
          return (
            <div key={stage.id} className="stage-wrapper">
              {/* Stage Card */}
              <div className={`stage-card ${stage.status}`}>
                <div className="stage-icon-wrapper">
                  <Icon className={`stage-icon ${stage.status}`} />
                </div>
                <div className="stage-content">
                  <h3 className="stage-name">{stage.name}</h3>
                  <p className="stage-description">{stage.description}</p>
                  <span className={`stage-badge ${stage.status}`}>
                    {stage.status === 'completed' && '✓ Completed'}
                    {stage.status === 'in-progress' && '⏳ In Progress'}
                    {stage.status === 'pending' && '○ Pending'}
                  </span>
                </div>
              </div>

              {/* Connector Line */}
              {!isLast && (
                <div className={`stage-connector ${stages[index + 1]?.status === 'completed' ? 'completed' : ''}`}></div>
              )}
            </div>
          );
        })}
      </div>

      {/* Info Box */}
      <div className="tracker-info-box">
        <h4>📋 Application Details</h4>
        <div className="info-grid">
          <div className="info-item">
            <label>Application Status:</label>
            <span>In Progress</span>
          </div>
          <div className="info-item">
            <label>Estimated Days:</label>
            <span>5-7 days</span>
          </div>
          <div className="info-item">
            <label>Last Updated:</label>
            <span>Today</span>
          </div>
          <div className="info-item">
            <label>Next Step:</label>
            <span>Sanction Process</span>
          </div>
        </div>
      </div>

      {/* Help Section */}
      <div className="tracker-help">
        <h4>Need Help?</h4>
        <p>You can check your application status anytime by logging into your account or contact our customer support team at <strong>waadiiai.socials@gmail.com</strong></p>
      </div>
    </div>
  );
};

export default LoanStatusTracker;
